const drivers = {
  table: {
    filters: {
      suppliers: 'ציים',
    },
  },

  forms: {
    information: {
      supplier: {
        header: 'ציים',
        fields: {
          suppliers: 'ציים',
        },
      },
    },
  },
};

export default drivers;
